module.exports = "<div class=\"icon sentiment {{sentiment}}\"></div>{{text}}";